import { motion, AnimatePresence } from "framer-motion";

const OVERLAY =
    "fixed inset-0 z-50 flex items-center justify-center bg-[rgba(18,22,31,0.45)]";
const CARD =
    "bg-white rounded-[3vh] shadow-[0_3vh_8vh_rgba(18,22,31,0.28)] px-[4vw] py-[3.4vh] flex flex-col items-center gap-[1.4vh]";

function Spinner() {
    return (
        <svg
            className="w-[4vh] h-[4vh]"
            style={{ animation: "spin 0.8s linear infinite" }}
            viewBox="0 0 24 24"
            fill="none"
            stroke="#246CE2"
            strokeWidth="2.4"
            strokeLinecap="round"
        >
            <path d="M21 12a9 9 0 1 1-2.6-6.4M21 3v6h-6" />
        </svg>
    );
}

function LoadingOverlay({ loading, loadingPayment, messages, loadingMessage, t, showCancelPayment, onCancelPayment }) {
    if (loading) {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className={OVERLAY}
            >
                <div className={CARD}>
                    <Spinner />
                    <div className="text-[1.9vh] font-bold text-[#12161F]">
                        {t("editDoc.loading")}
                    </div>
                </div>
            </motion.div>
        );
    }

    if (loadingPayment) {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className={OVERLAY}
            >
                <div className={CARD}>
                    <Spinner />
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={loadingMessage}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                            className="text-[1.9vh] font-bold text-[#12161F]"
                        >
                            {messages[loadingMessage]}
                        </motion.div>
                    </AnimatePresence>
                    {showCancelPayment && (
                        <motion.button data-analytics="loadingoverlay.editDoc.cancel_payment_request.1"
                            type="button"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            onClick={onCancelPayment}
                            className="mt-[0.6vh] px-[2.4vw] py-[1.1vh] rounded-full bg-[#F1F3F7] text-[1.6vh] font-bold text-[#12161F] active:bg-[#E1E4EB] transition-colors"
                        >
                            {t("editDoc.cancel_payment_request")}
                        </motion.button>
                    )}
                </div>
            </motion.div>
        );
    }

    return null;
}

export default LoadingOverlay;
